import SearchIcon from '@mui/icons-material/Search';
import { CircularProgress, TextField } from '@mui/material';
import React from 'react';

interface IProps {
  value: string;
  onChange: React.Dispatch<React.SetStateAction<string>>;
  isLoading?: boolean;
  placeholderText: string;
}

export const SearchInput: React.FC<IProps> = ({ value, onChange, isLoading, placeholderText }) => {
  return (
    <TextField
      placeholder={`Look up ${placeholderText}`}
      onChange={(e) => onChange(e.target.value)}
      value={value}
      fullWidth
      slotProps={{
        input: {
          endAdornment: isLoading ? <CircularProgress size="30px" /> : <SearchIcon />,
        },
      }}
    />
  );
};
